import { createFileRoute, Outlet } from "@tanstack/react-router";
import AddClientLayout from "@/app/admin/add-client/layout";

export const Route = createFileRoute("/admin/add-client/$clientId")({
  component: () => (
    <AddClientLayout>
      <Outlet />
    </AddClientLayout>
  ),
});
